import { render, staticRenderFns } from "./company_edit.vue?vue&type=template&id=b14496c0"
import script from "./company_edit.vue?vue&type=script&lang=js"
export * from "./company_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports